import React from "react";
import { AuthProvider } from "./contexts/auth.context";
import FontLoader from "./components/font-loader/font-loader";
import { preloadedFonts } from "./constants/fonts";
import { ToastContainer } from "react-toastify";
import Main from "./Main";

import "react-toastify/dist/ReactToastify.css";

function App() {
  return (
    <AuthProvider>
      <FontLoader fonts={preloadedFonts} />
      <Main />
      <ToastContainer theme="dark" position="top-center" />
    </AuthProvider>
  );
}

export default App;
